import React from 'react'

const LoadingPage = () => (
	<div className="loading-page">
		<i className="fad fa-spinner-third fa-spin" />
	</div>
)

export default LoadingPage
